import { useEffect, useState } from "react";
import { PageHeader, StatusPill, fmtINR } from "./Primitives";
import { db } from "@/lib/data";
import { supabase } from "@/lib/supabase";
export function LiveAdminPage({
  title,
  description,
  table,
  columns,
  select = "*",
  order = "created_at",
}: any) {
  const [r, setR] = useState<any[]>([]),
    [loading, setLoading] = useState(true);
  const load = async () => {
    setLoading(true);
    const q = supabase
      .from(table)
      .select(select)
      .order(order, { ascending: false });
    const { data, error } = await q;
    if (error) console.error(error);
    setR(data || []);
    setLoading(false);
  };
  useEffect(() => {
    load();
  }, [table]);
  return (
    <div className="space-y-6">
      <PageHeader title={title} description={description} />
      {loading ? (
        <div>Loading…</div>
      ) : (
        <div className="overflow-x-auto rounded-2xl border border-border bg-card">
          <table className="w-full text-sm">
            <thead className="bg-muted/40 text-xs uppercase">
              <tr>
                {columns.map((c: any) => (
                  <th className="p-3 text-left" key={c.key}>
                    {c.label}
                  </th>
                ))}
                <th />
              </tr>
            </thead>
            <tbody>
              {r.map((x) => (
                <tr className="border-t border-border" key={x.id}>
                  {columns.map((c: any) => (
                    <td className="p-3" key={c.key}>
                      {c.render ? c.render(x) : String(x[c.key] ?? "—")}
                    </td>
                  ))}
                  <td className="p-3" />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}